<template>
    <SmartLinkItemComponent
        :id="model.system.id"
        :component="!model.system.workflow"
        custom-tag="section"
    >
        <div class="iframe-embed" data-aos="fade-up">
            <div class="container">
                <SmartLinkStandaloneElement :codename="typ.elements.title.codename">
                    <p v-if="data.title" class="iframe-embed__title">
                        {{ data.title }}
                    </p>
                </SmartLinkStandaloneElement>

                <SmartLinkStandaloneElement :codename="typ.elements.url.codename" custom-tag="div">
                    <iframe
                        v-if="data.url"
                        :src="data.url"
                        :title="data.title || 'Embedded content'"
                        :style="{ height: `${height}px` }"
                        class="iframe-embed__frame"
                        allow="fullscreen; autoplay; encrypted-media; picture-in-picture"
                        allowfullscreen
                        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation"
                        loading="lazy"
                    />
                </SmartLinkStandaloneElement>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { IframeModel } from '~/models';
import { contentTypes } from '~/models';

const typ = contentTypes.iframe;

const props = defineProps<{ model: IframeModel }>();

const data = {
    title: props.model.elements.title.value,
    url: props.model.elements.url.value,
    height: props.model.elements.height.value
};

const height = computed(() => data.height ?? 500);
</script>

<style scoped>
.iframe-embed__frame {
    width: 100%;
    border: none;
    display: block;
}
</style>
